'use client';

import { LanguageSelector } from '@kit/ui/language-selector';

import { setLocaleAction } from '~/lib/i18n/set-locale';

/**
 * Client half of the public language control: routes every change through the
 * single writer in set-locale.ts. The explicit choice is read from the cookie
 * by the server half (footer-language-selector.tsx) and passed in.
 */
export function LocaleSelector(props: {
  selectedLocale: string | null;
  variant?: 'inline' | 'footer' | 'header';
  className?: string;
}) {
  return (
    <LanguageSelector
      variant={props.variant ?? 'footer'}
      selectedLocale={props.selectedLocale}
      className={props.className}
      onChange={(locale) => setLocaleAction({ locale })}
    />
  );
}
